import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  PatientRecord,
  PatientRecordPayload,
} from "@project/types/patient-record";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/patient-records`;
const SILENT: RequestConfig = { showNotification: false };

class PatientRecordService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<PatientRecord>> => {
    return fetchListPage<PatientRecord>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<PatientRecord | undefined> => {
    const data = await get<ApiItemResponse<PatientRecord> | PatientRecord>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: PatientRecordPayload
  ): Promise<PatientRecord | undefined> => {
    const data = await post<
      ApiItemResponse<PatientRecord> | PatientRecord,
      PatientRecordPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<PatientRecordPayload>
  ): Promise<PatientRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<PatientRecord> | PatientRecord,
      Partial<PatientRecordPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const patientRecordService = new PatientRecordService();
